import { TUpdateUserPasswordParams } from 'types/services';
import { m8API } from 'services/production/m8';

export const updateUserPassword = async (params: TUpdateUserPasswordParams) => {
  const { nextPassword, actualPassword } = params;

  await m8API.user.changeClientPassword({
    newPassword: nextPassword,
    oldPassword: actualPassword,
  });
};
